var _rect, _path, _circle, _circle2, _path2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 30,
    fill: "#EEF7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 27v30c0 18 10 28 22 28s22-10 22-28V27",
    fill: "none",
    stroke: "#1676D2",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 26,
    r: 6,
    fill: "#17B4D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 26,
    r: 6,
    fill: "#17B4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85c0 12 9 17 18 17 8 0 14-4 17-11",
    fill: "none",
    stroke: "#0A56A5",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 86,
    r: 9,
    fill: "white",
    stroke: "#0A56A5",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.ec3e6c04c1f594150dba4fb127cd391b.svg";
export { ForwardRef as ReactComponent };